module.exports = __webpack_public_path__ + "img/rateStarNoB.11f3d20a.svg";